import { motion } from "framer-motion";

const Skills = () => {
  const skills = [
    'Python', 'Java', 'C++', 'HTML', 'CSS', 
    'FastAPI', 'Streamlit', 'Django', 'React', 'Spring Boot',
    'Google Cloud Platform', 'TensorFlow',
    'PostgreSQL', 'MySQL', 'Qdrant',
    'LLMs: Gemini, Llama, Mixtral'
  ];

  return (
    // <section id="skills" className="h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
    <section id="skills" className="md:h-screen min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
      <div className="container mx-auto px-8 text-center">
        
        {/* Animated Heading */}
        <motion.h2
          className="text-5xl font-extrabold text-gray-900 relative inline-block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Skills
          <span className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-600 to-purple-500 rounded-lg"></span>
        </motion.h2>

        {/* Skills Grid */}
        <motion.div
          className="mt-12 flex flex-wrap justify-center gap-4 max-w-4xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {skills.map((skill, index) => (
            <motion.span
              key={skill}
              className="px-5 py-3 text-lg font-medium bg-white text-gray-800 rounded-full shadow-lg border border-gray-300 transition-transform hover:scale-105"
              whileHover={{ scale: 1.1 }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.5 }}
            >
              {skill}
            </motion.span>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Skills;
